import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '../..';
import { studentCompetencyDataService } from '@/service/api/student-competency-data.service';
import { StudentCompetencyDistribution } from '@/models/student/student-competency-data';
import { CompetencyDistributionRequest } from '@/models/competency/competency-distribution-request';
import { StudentCompetencyGrowth } from '@/models/student/student-competency-growth';

export interface IStudentAllCompetencyState {
  studentCompetencyDistributions: StudentCompetencyDistribution[]; // 生徒コンピテンシー分布情報
  studentCompetencyGrowth: StudentCompetencyGrowth[];
}
@Module({ dynamic: true, store, name: 'studentAllCompetencyModule', namespaced: true })
class StudentAllCompetencyModule extends VuexModule implements IStudentAllCompetencyState {
  studentCompetencyDistributions: StudentCompetencyDistribution[] = [];
  studentCompetencyGrowth: StudentCompetencyGrowth[] = [];

  get sortDiffScore(): StudentCompetencyGrowth[] {
    const copyCompetencyGrowth = this.studentCompetencyGrowth.slice();
    copyCompetencyGrowth.sort((a: StudentCompetencyGrowth, b: StudentCompetencyGrowth) => {
      if (a.courseResults.length > 1 && b.courseResults.length > 1) {
        const diffScoreA = Math.abs(a.lastCourseResult.percentScore - a.latestCourseResult.percentScore);
        const diffScoreB = Math.abs(b.lastCourseResult.percentScore - b.latestCourseResult.percentScore);
        return diffScoreA > diffScoreB ? -1 : 1;
      }
      if (a.courseResults.length > 1) {
        return -1;
      }
      if (b.courseResults.length > 1) {
        return 1;
      }
      return 0;
    });
    return copyCompetencyGrowth;
  }

  get maxCount(): number {
    return Math.max.apply(
      null,
      this.studentCompetencyDistributions.map((data: StudentCompetencyDistribution) => {
        if (data.organization.data.length > 0) {
          return Math.max.apply(null, data.organization.data.map((d: any) => d[2]));
        }
        return 0;
      })
    );
  }

  @Mutation
  setStudentCompetencyDistributions(value: StudentCompetencyDistribution[]) {
    this.studentCompetencyDistributions = value;
  }

  @Mutation
  setstudentCompetencyGrowth(value: StudentCompetencyGrowth[]) {
    this.studentCompetencyGrowth = value;
  }

  @Mutation
  clean() {
    this.studentCompetencyDistributions = [];
    this.studentCompetencyGrowth = [];
  }
  /**
   * ある学生の全コンピテンシーのスコア推移を取得
   * @param studentID 学生ID
   */
  @Action({ rawError: true })
  async fetchstudentCompetencyGrowth(studentID: number): Promise<StudentCompetencyGrowth[]> {
    const result = await studentCompetencyDataService.getStudentCompetencyGrowth(studentID);
    this.setstudentCompetencyGrowth(result);
    return result;
  }
  /**
   * ある学生のコンピテンシー分布を取得
   * @param student 学生情報
   */
  @Action({ rawError: true })
  async fetchStudentCompetencyDistributions(request: CompetencyDistributionRequest): Promise<StudentCompetencyDistribution[]> {
    const result = await studentCompetencyDataService.getStudentCompetencyDistributions(request.studentID, request.targetType, request.targetID);
    this.setStudentCompetencyDistributions(result);
    return result;
  }
}

export const studentAllCompetencyModule = getModule(StudentAllCompetencyModule);
